import httpClient from '@/http-client'

export const getApprovalList = (Options = {}) => {
  return httpClient
    .get('/api/v1/approval-requests', Options)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}

export const store = data => {
  return httpClient
    .post('/api/v1/approval-requests', data)
    .then(response => Promise.resolve(response.data))
    .catch(error => Promise.reject(error.response.data))
}


export default { getApprovalList, store }